var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1064 15C12.8713 15 15.1127 12.7614 15.1127 10C15.1127 7.23858 12.8713 5 10.1064 5C7.34154 5 5.10016 7.23858 5.10016 10C5.10016 12.7614 7.34154 15 10.1064 15ZM10.1064 17C13.9772 17 17.1152 13.866 17.1152 10C17.1152 6.13401 13.9772 3 10.1064 3C6.23559 3 3.09766 6.13401 3.09766 10C3.09766 13.866 6.23559 17 10.1064 17Z",
    fill: "#FF9A53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.407 16.2929C16.798 15.9024 17.432 15.9024 17.823 16.2929L21.3274 19.7929C21.7184 20.1834 21.7184 20.8166 21.3274 21.2071C20.9364 21.5976 20.3024 21.5976 19.9114 21.2071L16.407 17.7071C16.016 17.3166 16.016 16.6834 16.407 16.2929Z",
    fill: "#F7D159"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.540b5d2014354f36912fb39bb2ed09f5.svg";
export { ForwardRef as ReactComponent };